<div class="pl-pane__container--horizontal">
<header class="pl-page-header pl-pane--shrink">
  <h1 class="pl-heading--xlarge">
    {{ 'REGISTRATIONS.registrations' | translate }}
  </h1>
</header>

<se-fe-tabs [seFeDataTabs]="tabs" seFeDataAriaLabel="Registration views"></se-fe-tabs>

<router-outlet></router-outlet>
</div>
